import React, { useState } from "react";
import { HelperText, Subtitle, ModalPattern } from "@worthy-npm/clarity";
import { browserHistory } from "react-router";
import SmallCTAcard from "./smallCTAcard";
import ComingSoon from "./comingSoon";

const DIYSection = ({ data, horizScroll, recomended }) => {
    const [openComingSoon, setOpenComingSoon] = useState(0);
    const [closeFakeDoorModal, setCloseFakeDoorModal] = useState(0);

    const allCards = {
        HOW_TO_PRICE: {
            type: "resource",
            title: "How pre-owned diamond jewelry is priced",
            subtitle: "Pricing guide",
            CTAcallBack: () => {
                browserHistory.push("/learn/how-to-price");
            },
        },
        WHERE_TO_SELL: {
            type: "resource",
            title: "Where to sell pre-owned diamond jewelry",
            subtitle: "Comparative analysis",
            CTAcallBack: () => {
                browserHistory.push("/learn/where-to-sell");
            },
        },
        CALC_BY_ATTR: {
            type: "tool",
            title: "Resale diamond attributes price range calculator",
            subtitle: "Based on attributes",
            CTAcallBack: () => {
                browserHistory.push("/learn/calculator");
            },
        },
    };

    let filteredData = [];
    if (data) {
        data.forEach((initial) => {
            filteredData.push(allCards[initial]);
        });
    } else {
        filteredData = Object.values(allCards);
    }

    const comingSoonMobile = (
        <ModalPattern
            key={"ModalPattern"}
            textAlign={"center"}
            closeIcon={true}
            closeOnClickOutside={true}
            isWide={true}
            closeOnEscape={false}
            closeNow={closeFakeDoorModal}
            onClose={() => {
                setOpenComingSoon(false);
            }}
        >
            <ComingSoon
                click={() => {
                    setCloseFakeDoorModal(true),
                        () => {
                            setCloseFakeDoorModal(false);
                        };
                }}
            />
        </ModalPattern>
    );

    const topSection = recomended ? (
        <Subtitle text={"Recommended for you"} />
    ) : (
        <React.Fragment>
            <HelperText text={"Do your own research"} />
            <Subtitle text={"DIY Resources & Tools"} bold={true} />
        </React.Fragment>
    );

    if (horizScroll) {
        return (
            <div
                id="dyi_resources_and_tools"
                className="DIY-section horizontal margin-0-auto"
            >
                <div className="text-container">{topSection}</div>
                <div className="slider d-flex">
                    <div className={"small-cards-container d-flex"}>
                        {filteredData.map((card, i) => {
                            return (
                                <SmallCTAcard
                                    key={i}
                                    type={card.type}
                                    title={card.title}
                                    subtitle={card.subtitle}
                                    CTAcallBack={card.CTAcallBack}
                                />
                            );
                        })}
                    </div>
                </div>
                {openComingSoon ? comingSoonMobile : null}
            </div>
        );
    }
    return (
        <div className="DIY-section margin-0-auto">
            {topSection}
            <div className={"small-cards-container"}>
                {filteredData.map((card, i) => {
                    return (
                        <SmallCTAcard
                            key={i}
                            type={card.type}
                            title={card.title}
                            subtitle={card.subtitle}
                            CTAcallBack={card.CTAcallBack}
                        />
                    );
                })}
            </div>
            {openComingSoon ? comingSoonMobile : null}
        </div>
    );
};

export default DIYSection;
